import { EditButton, Show } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import BasicInfoSection from "./Show/BasicInfoSection";
import SpecializationsSection from "./Show/SpecializationsSection";
import ExamsSection from "./Show/ExamsSection";
import TaxesSection from "./Show/TaxesSection";
import DocumentsSection from "./Show/DocumentsSection";
import IbansField from "./Show/IbansField";

const ShowCampaigns = () => {
  return (
    <Show
      title="Детайли на кампания"
      actions={
        <BackButtonToolbar
          additionalButton={
            <EditButton
              variant="contained"
              size="medium"
            />
          }
        />
      }
    >
      <BasicInfoSection />
      <SpecializationsSection />
      <ExamsSection />
      <TaxesSection />
      <DocumentsSection />
      <IbansField />
    </Show>
  );
};

export default ShowCampaigns;
